/* =============================================================
   hs-popup.js — Horlogerieshop.nl
   Promo bar + Newsletter popup
   ============================================================= */

(function () {
  'use strict';

  var BAR_SESSION_KEY = 'hs-promo-bar-closed';
  var popup = null;
  var lastTrigger = null;
  var currentDiscountCode = '';

  /* ============================================================
     PROMO BAR
     ============================================================ */

  function initPromoBar() {
    var bar = document.getElementById('hs-promo-bar');
    if (!bar) return;

    if (sessionStorage.getItem(BAR_SESSION_KEY)) {
      bar.hidden = true;
      return;
    }

    var closeBtn = bar.querySelector('.hs-promo-bar__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        bar.hidden = true;
        sessionStorage.setItem(BAR_SESSION_KEY, '1');
      });
    }
  }

  /* ============================================================
     POPUP
     ============================================================ */

  function initPopup() {
    popup = document.getElementById('hs-newsletter-popup');
    if (!popup) return;

    popup.querySelectorAll('[data-hs-popup-close]').forEach(function (el) {
      el.addEventListener('click', closePopup);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup && !popup.hidden) closePopup();
    });

    var submitBtn = document.getElementById('hs-popup-submit');
    if (submitBtn) submitBtn.addEventListener('click', handleSubmit);

    var copyBtn = document.getElementById('hs-popup-copy');
    if (copyBtn) copyBtn.addEventListener('click', handleCopy);
  }

  function openPopup(trigger) {
    if (!popup) return;
    lastTrigger = trigger;

    var title    = trigger.dataset.hsPopupTitle;
    var subtitle = trigger.dataset.hsPopupSubtitle;
    var code     = trigger.dataset.hsDiscountCode;

    var titleEl = document.getElementById('hs-popup-title');
    var subEl   = document.getElementById('hs-popup-subtitle');

    if (title && titleEl)  titleEl.textContent = title;
    if (subtitle && subEl) subEl.textContent   = subtitle;
    if (code)              currentDiscountCode = code;

    showFormState();
    popup.hidden = false;
    document.body.style.overflow = 'hidden';

    setTimeout(function () {
      var first = popup.querySelector('.hs-popup__input');
      if (first) first.focus();
    }, 60);
  }

  function closePopup() {
    if (!popup) return;
    popup.hidden = true;
    document.body.style.overflow = '';
    if (lastTrigger) { lastTrigger.focus(); lastTrigger = null; }
  }

  function showFormState() {
    var formState    = popup.querySelector('[data-state="form"]');
    var successState = popup.querySelector('[data-state="success"]');
    if (formState)    formState.hidden = false;
    if (successState) successState.hidden = true;

    var submitBtn = document.getElementById('hs-popup-submit');
    if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Bevestig'; }

    var emailInput = document.getElementById('hs-popup-email');
    var nameInput  = document.getElementById('hs-popup-firstname');
    if (emailInput) emailInput.value = '';
    if (nameInput)  nameInput.value  = '';
    hideError();
  }

  function showSuccessState() {
    var formState    = popup.querySelector('[data-state="form"]');
    var successState = popup.querySelector('[data-state="success"]');
    if (formState)    formState.hidden = true;
    if (successState) successState.hidden = false;

    var codeEl = document.getElementById('hs-popup-code');
    if (codeEl && currentDiscountCode) codeEl.textContent = currentDiscountCode;

    var successTitle = popup.querySelector('.hs-popup__success-title');
    if (successTitle) successTitle.focus();

    // Sla code op voor na redirect
    if (currentDiscountCode) sessionStorage.setItem('hs-discount-code', currentDiscountCode);

    // Gebruik de bestaande footer newsletter form — die heeft een geldige CAPTCHA token
    var emailInput = document.getElementById('hs-popup-email');
    if (emailInput) submitViaFooterForm(emailInput.value.trim());
  }

  function submitViaFooterForm(email) {
    var footerForm = document.querySelector('.newsletter-form');
    if (!footerForm) return;

    var emailField = footerForm.querySelector('[name="contact[email]"]');
    if (!emailField) return;

    // Vul email in
    emailField.value = email;

    // Voeg return_to toe zodat pagina terugkeert met success parameter
    var returnInput = footerForm.querySelector('[name="return_to"]');
    if (!returnInput) {
      returnInput = document.createElement('input');
      returnInput.type = 'hidden';
      returnInput.name = 'return_to';
      footerForm.appendChild(returnInput);
    }
    returnInput.value = window.location.pathname + '?hs_success=1';

    // Submit na korte delay zodat succes scherm zichtbaar is
    setTimeout(function () {
      footerForm.submit();
    }, 1500);
  }

  /* ============================================================
     SUBMIT — alleen lokale validatie, geen server call
     ============================================================ */

  function handleSubmit() {
    var nameInput  = document.getElementById('hs-popup-firstname');
    var emailInput = document.getElementById('hs-popup-email');

    var firstName = nameInput  ? nameInput.value.trim()  : '';
    var email     = emailInput ? emailInput.value.trim() : '';

    if (!firstName) {
      showError('Vul uw voornaam in.');
      if (nameInput) nameInput.focus();
      return;
    }

    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      showError('Vul een geldig e-mailadres in.');
      if (emailInput) emailInput.focus();
      return;
    }

    hideError();
    showSuccessState();
  }

  function showError(msg) {
    var el = document.getElementById('hs-popup-error');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
  }

  function hideError() {
    var el = document.getElementById('hs-popup-error');
    if (el) el.hidden = true;
  }

  /* ============================================================
     COPY CODE
     ============================================================ */

  function handleCopy() {
    var codeEl  = document.getElementById('hs-popup-code');
    var copyBtn = document.getElementById('hs-popup-copy');
    if (!codeEl || !copyBtn) return;

    var code = codeEl.textContent.trim();
    var originalHTML = copyBtn.innerHTML;
    var checkIcon = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12.5L9.2 16.7L19 6.9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    function showCheck() {
      copyBtn.innerHTML = checkIcon;
      copyBtn.setAttribute('aria-label', 'Gekopieerd!');
      setTimeout(function () {
        copyBtn.innerHTML = originalHTML;
        copyBtn.setAttribute('aria-label', 'Kopieer kortingscode');
      }, 2000);
    }

    if (navigator.clipboard) {
      navigator.clipboard.writeText(code).then(showCheck).catch(showCheck);
    } else {
      var ta = document.createElement('textarea');
      ta.value = code;
      ta.style.cssText = 'position:fixed;opacity:0;pointer-events:none;';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
      showCheck();
    }
  }

  /* ============================================================
     EVENT DELEGATION
     ============================================================ */

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-hs-popup-trigger]');
    if (trigger) {
      e.preventDefault();
      openPopup(trigger);
    }
  });

  /* ============================================================
     INIT
     ============================================================ */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initPromoBar();
      initPopup();
      checkPostRedirect();
    });
  } else {
    initPromoBar();
    initPopup();
    checkPostRedirect();
  }

  function checkPostRedirect() {
    if (window.location.search.indexOf('hs_success=1') === -1) return;

    var code = sessionStorage.getItem('hs-discount-code');
    if (code) currentDiscountCode = code;

    popup = document.getElementById('hs-newsletter-popup');
    if (!popup) return;

    var formState    = popup.querySelector('[data-state="form"]');
    var successState = popup.querySelector('[data-state="success"]');
    if (formState)    formState.hidden = true;
    if (successState) successState.hidden = false;

    var codeEl = document.getElementById('hs-popup-code');
    if (codeEl && currentDiscountCode) codeEl.textContent = currentDiscountCode;

    popup.hidden = false;
    document.body.style.overflow = 'hidden';

    // Verwijder parameter uit URL
    var cleanUrl = window.location.pathname + window.location.search
      .replace(/[?&]hs_success=1/, '').replace(/^\?$/, '');
    window.history.replaceState({}, '', cleanUrl || window.location.pathname);
  }

})();
